import { render } from "./SliderVideo.vue?vue&type=template&id=6b9040f6"
import script from "./SliderVideo.vue?vue&type=script&lang=js"
export * from "./SliderVideo.vue?vue&type=script&lang=js"

import "./SliderVideo.vue?vue&type=style&index=0&id=6b9040f6&lang=css"

import exportComponent from "C:\\Proyectos\\Vue3\\player-video-pepsi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__